<template>
    <div class="border">
        <div class="eligibleAmount">
            <div class="title">
                {{ portfolio.planType | capitalize }} {{ portfolio.riskProfile | capitalize }}
            </div>
            <div class="amount">
                &#x20B9;{{ withdrawableAmount | localeAmountPaisaToRupee }}
                <span>
                    <img src="/img/up.png" alt="" style="padding: 0px 4px;">
                </span>
            </div>
            <div>
                <span>
                   {{ getTransactions[0].creditedAt | customFormatDate }}
                </span>
            </div>

        </div>
        <div v-if="withdrawableAmount" class="eligibility">
            <div class="square green"></div>
            <span style="font-size: 12px; color: #39AF01;">
                Eligible for withdrawal
            </span>
        </div>
        <div style="padding: 36px" class="transactionContainer">
            <div>
                <h3>
                    Transactions
                </h3>
            </div>
            <div v-for="( transaction, index) in getTransactions" :key="index" class="transactions" >
                <div class="content flexCenterAlign">
                    <img src="/img/incoming.png" alt="" style="margin-left: 10px; margin-right: 24px;">
                    <div>
                        <div class="credited">
                            Invested on {{ transaction.creditedAt | formatDate }}
                        </div>
                        <div class="actionTitle" v-if="checkIfInEligible(transaction)">
                            <div class="square yellow"></div>
                            <span style="font-size: 12px; color: #007AFF;">
                                Repayment Pending
                            </span>
                            <v-tooltip class = "tooltipContainer" max-width = "300px" top color="#ffffff">
                                <template v-slot:activator="{on, attrs}">
                                    <img v-bind="attrs" v-on="on" class = "cautionImage" src = "/img/caution_icon.svg" >
                                </template>
                                <div>
                                    <span class = "spanText">
                                        Repayment delayed. Withdrawal on hold until payment is received.
                                    </span>
                                </div>
                            </v-tooltip>
                        </div>
                        <div class="actionTitle" v-else-if="transaction.isEligible">
                            <div class="square green"></div>
                            <span style="font-size: 12px; color: #007AFF;" v-if="withdrawableAmount">
                                Unlocked
                            </span>
                            <span style="font-size: 12px; color: #007AFF;" v-else>
                                Ineligible for withdrawal
                            </span>
                            <v-tooltip class = "tooltipContainer" max-width = "300px" top color="#ffffff">
                                <template v-slot:activator="{on, attrs}">
                                    <img v-bind="attrs" v-on="on" class = "cautionImage" src = "/img/caution_icon.svg" >
                                </template>
                                <div>
                                    <span class = "spanText" v-if="withdrawableAmount">
                                        Investments made 12 months ago are eligible for withdrawal. Small variation in the stated
                                        amount may be seen on account of multiple investments being combined
                                        into the same plan and/or some part of the investment still being deployed in loans bearing interest.
                                    </span>
                                    <span class = "spanText" v-else>
                                        Some part of this investment has been deployed in loans bearing interest, and should be available for withdrawal soon.
                                    </span>
                                </div>
                            </v-tooltip>
                        </div>
                        <div class="actionTitle" v-else>
                            <img src="/img/lock-blue.svg" alt="" style="margin-right: 8px;">
                            <span style="font-size: 12px; color: #A4A4A4;">
                                Unlocked by {{ transaction.creditedAt | nextYear | formatDate }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="transactionAmount">
                    &#x20B9;{{ transaction.amount | localeAmountPaisaToRupee}}
                </div>
            </div>
            <div class="pt-20 w-100 buttonFixed" style="text-align: center;">
                <BaseButton buttonClass="withdrawButton" @click="withdrawPortfolio(portfolio)" :disabled="isWithdrawDisabled">
                    <span v-if="!isCheckLoading">
                        Continue to withdraw
                    </span>
                    <v-progress-circular
                        indeterminate
                        color="grey"
                        :size="20"
                        style="margin-right: 16px"
                        v-else
                    ></v-progress-circular>
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script>
import LenderService from '@/services/lenderService'
import BaseButton from '@/components/common/uiComponents/baseButton.vue'

export default {
    name: 'ViewWithdrawalTransactions',
    components: {
        BaseButton
    },
    props: {
        selectedPortfolio: {
            type: Object
        }
    },
    data () {
        return {
            portfolio: this.selectedPortfolio,
            isCheckLoading: false,
            isWithdrawDisabled: true,
            withdrawableAmount: 0
        }
    },
    filters: {
        nextYear (value) {
            const date = new Date(value)
            const year = date.getFullYear() + 1
            const month = date.getMonth()
            const day = date.getDate()
            return new Date(year, month, day)
        }
    },
    computed: {
        getTransactions () {
            const transactions = this.portfolio.transactions.filter(i => (i.isProcessed !== 'full' || (i.ineligibleAmount && i.ineligibleAmount > 0)))
            if (!transactions.length) {
                this.callFunction()
            }
            return transactions
        }
    },
    async mounted () {
        this.isCheckLoading = true
        this.$store.commit('isLoading', { message: 'We are calculating your withdrawal amount!' })
        const queryString = 'portfolioId=' + this.portfolio.portfolioId
        const response = await LenderService.getWithdrawalSummary(queryString)
        this.portfolioData = response.data.portfolio
        this.withdrawableAmount = response.data.withdrawableAmount
        this.isCheckLoading = false
        this.$store.commit('isNotLoading')

        this.portfolio.transactions.forEach((transaction) => {
            if (!transaction.isEligible || !this.withdrawableAmount) {
            } else if (transaction.isEligible && (transaction.isProcessed !== 'full' || this.withdrawableAmount)) {
                this.isWithdrawDisabled = false
            } else if (transaction.ineligibleAmount) {
                this.isWithdrawDisabled = true
            }
        })
    },
    methods: {
        checkIfInEligible (transaction) {
            console.log('trans', transaction)
            if (!this.withdrawableAmount && transaction.ineligibleAmount) {
                return true
            }
            return false
        },
        withdrawPortfolio () {
            this.$emit('withdrawPortfolio', this.portfolio)
        }
    }
}
</script>

<style lang="scss" scoped>
    .main {
        padding-bottom: 8px;
    }

    .portfolioName {
        font-size: 17px;
        color: #232323;
        font-weight: 500;
        line-height: 16px;
    }

    .createdDate {
        font-size: 13px;
        text-transform: capitalize;
        color: #8C8C8C;
    }

    .square {
        display: inline-block;
        border-radius: 1px;
        width: 8px;
        height: 8px;
        margin-right: 8px;
    }

    .green {
        background: #39AF01;
    }

    .yellow {
        background: #FFCB05;
    }

    .blue {
        background: #5D5FEF;
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 8px;
        cursor: pointer;
    }

    .transactions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 8px;
        margin: 8px 0px;
        border: 0.6px solid #F2F6FF;
        background: #FFFFFF;
    }

    button {
        padding: 11px 24px;
        border-radius: 6px;
        letter-spacing: 0.005em;
        font-size: 14px;
        line-height: 150%;
        font-weight: 600;
        width: 100%;
    }

    .withdrawButton {
        margin: 12px 0px;
        background: #002FA7;
        color: #FFFFFF;
        width: 60%;
        position: absolute;
    }

    .transactionAmount {
        font-weight: 400;
    }

    .heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .amount {
        font-size: 21px;
        font-weight: 700;
    }

    .content {
        width: 60%;
    }

    .credited {
        font-size: 13px;
    }

    .title {
        line-height: unset
    }

    .v-expansion-panel--active > .v-expansion-panel-header {
        min-height: 50px;
    }

    .container-2 {
        margin-bottom: 32px
    }

    button:disabled {
        background-color: grey;
    }

    .v-expansion-panel-header--active {
        .right-chevron {
            transform: rotate(90deg)
        }
    }

    .right-chevron {
        background-image: url(/img/chevron-right.svg);
        width: 18px;
        height: 18px;
        background-size: contain;
    }

    .right-chevron-black {
        background-image: url(/img/chevron-right-black.svg);
        width: 18px;
        height: 18px;
        background-size: contain;
    }

    .actionTitle {
        cursor: pointer;
        display: flex;
        align-items: center;
        padding: 6px 0px;
    }

    .forhove {
        &:hover {
            background-color: #f2f6ff;
            color: #000000;
            border-radius: 0px;
            .dashboard-title {
                color: #000000 !important;
            }

            .plan-text {
                color: #000000 !important;
            }
        }
    }

    .tooltipContainer {
        padding: 16px !important;
        box-shadow: 5px 20px 24px -4px rgba(16, 24, 40, 0.1), 5px 8px 8px -4px rgba(16, 24, 40, 0.04);
        background-color: #ffffff !important;
    }

    .tooltipSubContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .v-tooltip__content {
        opacity: 1 !important;
        text-align: center !important;
        padding: 16px !important;
        box-shadow: 5px 20px 24px -4px rgba(16, 24, 40, 0.1), 5px 8px 8px -4px rgba(16, 24, 40, 0.04);
    }

    .earningsText {
        text-align: center;
        margin-bottom: 4px !important;
        font-weight: 600;
        font-size: 16px;
        color: #0f0f0f
    }
    .spanText {
        color: #8c8c8c;
        text-align: center !important;
        font-size: 11px !important
    }
    .cautionImage {
        margin-left : 10px;
        width: 16px !important;
        height: 16px !important;
        cursor: pointer;
    }

    .eligibleAmount {
        background: #002FA7;
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
        padding: 24px;
        color: #E0E0E0;

        .title {
            font-size: 12px !important;
        }

        .amount {
            display: flex;
            align-items: center;
            font-size: 32px;
        }

        span {
            font-size: 11px;
        }
    }

    .eligibility {
        background: rgba(57, 175, 1, 0.13);
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
        padding: 4px 8px;
    }

    .flexCenterAlign {
        display: flex;
        align-items: center;
    }

    .buttonFixed {
        position: sticky;
        bottom: -20px;
    }

    .transactionContainer {
        max-height: 500px;
        overflow-y: auto;
        position: relative;
    }

    .border {
        width: 100%;
    }

    .transactionContainer::-webkit-scrollbar {
        display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    .transactionContainer {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
</style>
